export enum ProgramAreas {
  physical = 0,
  cognitive = 1,
  respitory = 2,
  physiological = 3,
  social = 4,
  other = 5,
}
